import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '../../components/form-builder/form-builder.types';
import { BankDetails, Company, RefParams, BankDetailsDto } from '@/types';
import { refParamsInitialState } from '../ref-param-state/ref-param-state.store';
import { companyStateInitialState } from '../company-state/company-state.store';

export interface BankDetailsStateProps {
  response?: Partial<BankDetails>;
  dto?: Partial<BankDetailsDto>;
  bankDetailsCountrySelected?: SelectOption;
}

export const bankDetailsInitialState: BankDetailsStateProps = {
  response: {
    id: 0,
    nom: '',
    agence: '',
    societe: {
      ...(companyStateInitialState.response as Company),
    },
    rib: '',
    local: false,
    pays: { ...(refParamsInitialState.response as RefParams) },
  },
  dto: {
    nom: '',
    agence: '',
    rib: '',
    societeId: 0,
    paysId: 0,
  },
  bankDetailsCountrySelected: { name: '', code: 0 },
};

export const bankDetailsStateStore = createStore({ name: 'bank-details-state' }, withProps<BankDetailsStateProps>({ ...bankDetailsInitialState }));
